module.exports = __webpack_public_path__ + "img/setplex.2a5ba0.png";